import './RenderError.scss';
import * as React from 'react';
import * as Core from 'components/core';
type Props = {
  error: Error;
};
export default (props: Props) => (
  <div className="RenderError">
    <h1>We&apos;re sorry, something went wrong on our website!</h1>
    <p>
      We&apos;ve been notified of this error and are working to fix it. If you
      continue to experience a problem, please reach out to us at{' '}
      <Core.MailtoSupport />.
    </p>
    <p className="RenderError-errorCode">
      <Core.ErrorBox>
        {props.error.name} - {props.error.message}
      </Core.ErrorBox>
    </p>
  </div>
);
